import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { AppProvider } from "../context/RouteContext";
import Spinner from "../common/Spinner";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { NavLink } from "react-router-dom";
import toast from "react-hot-toast";
import { customAxios } from "../../service/CreateApi";
import moment from "moment";
import ErrorComponent from "../common/ErrorComponent";

const AttendanceTimeModal = ({ show, onClose }) => {
  let { get_username, userName, Loading } = useContext(AppProvider);

  const dateRef = useRef(null);
  const [rows, setRows] = useState([
    { clock_out: "", clock_in: "" }
  ]);
  const [form, setForm] = useState({
    userId: "",
    date: ""
  });
  const [error, setError] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errors, setErrors] = useState({
    userId: "",
    date: "",
    rows: []
  })

  useEffect(() => {
    get_username();
  }, []);

  const addRow = () => {
    setRows([...rows, { clock_in: "", clock_out: "" }]);
  };

  const removeRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });

    setErrors({
      ...errors,
      [name]:
        name === "userId"
          ? validateEmployee(value)
          : validateDate(value)
    });
  };

  const handleFormBlur = (e) => {
    handleFormChange(e);
  };


  const validateEmployee = (value) =>
    !value ? "Employee is required" : "";

  const validateDate = (value) =>
    !value ? "Work date is required" : "";

  const validateTimeRow = (row, index, allRows) => {
    let error = {};

    if (!row.clock_in) error.clock_in = "Clock in is required";
    if (!row.clock_out) error.clock_out = "Clock out is required";

    if (row.clock_in && row.clock_out && row.clock_in >= row.clock_out) {
      error.clock_out = "Clock out must be after clock in";
    }

    // ✅ previous row validation
    if (
      index > 0 &&
      row.clock_in &&
      allRows[index - 1].clock_out &&
      row.clock_in <= allRows[index - 1].clock_out
    ) {
      error.clock_in = "Clock in must be after previous clock out";
    }

    return error;
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleRowBlur = (index, field) => {
    const updatedErrors = [...(errors.rows || [])];

    if (!updatedErrors[index]) updatedErrors[index] = {};

    if (field === "clock_in") {
      if (!rows[index][field]) {
        updatedErrors[index][field] = "Clock in is required";
      } else if (
        field === "clock_in" &&
        index > 0 &&
        rows[index].clock_in &&
        rows[index - 1].clock_out &&
        rows[index].clock_in <= rows[index - 1].clock_out
      ) {
        updatedErrors[index].clock_in =
          "Clock in must be after previous clock out";
      } else {
        delete updatedErrors[index][field];
      }
    }
    if (field === "clock_out") {
      if (!rows[index][field]) {
        updatedErrors[index][field] = "Clock out is required";
      } else if (rows[index].clock_in && rows[index].clock_out && rows[index].clock_in >= rows[index].clock_out) {
        updatedErrors[index][field] = "Clock out must be after clock in";
      } else {
        delete updatedErrors[index][field];
      }
    }

    setErrors({ ...errors, rows: updatedErrors });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError([]);
    const newErrors = {
      userId: validateEmployee(form.userId),
      date: validateDate(form.date),
      rows: rows.map((row, index) =>
        validateTimeRow(row, index, rows)
      )
    };

    setErrors(newErrors);

    const hasErrors =
      newErrors.userId ||
      newErrors.date ||
      newErrors.rows.some((r) => Object.keys(r).length > 0);

    if (hasErrors) return;

    // ✅ ALL VALID — submit here
    const payload = {
      userId: form.userId,
      timestamp: form.date,
      time: rows.map((r) => {
        return { clock_in: moment(r.clock_in, "hh:mm:ss").format("hh:mm:ss A"), clock_out: moment(r.clock_out, "hh:mm:ss").format("hh:mm:ss A") }
      })
    };

    setisLoading(true);
    customAxios().post('/attendance/add', payload).then(data => {
      if (data.data.success) {
        toast.success(data.data.message);
        onClose(true);
      }
    }).catch((error) => {
      if (!error.response) {
        toast.error(error.message)
      } else {
        if (error.response.data.message) {
          toast.error(error.response.data.message)
        } else {
          setError(error.response.data.error);
        }
      }
    }).finally(() => setisLoading(false))
  };

  return (
    <>
      <Modal show={show} animation={true} size="md" aria-labelledby="example-modal-sizes-title-sm" className='department-modal' centered>
        <Modal.Header className='small-modal'>
          <Modal.Title>Attendance Time</Modal.Title>
          <p className='close-modal' onClick={onClose}><i className="fa-solid fa-xmark"></i></p>
        </Modal.Header>
        {/* Body */}
        <Modal.Body>
          <div className="grid-margin stretch-card inner-pages mb-lg-0">
            <div className="card">
              <div className="card-body set-padding">
                <form className="forms-sample" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* ====================   select  employee ============*/}
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="user" className='mt-3'>Employee</label>
                        <select className="form-control " id="user" name='userId' value={form.userId}
                          onChange={handleFormChange}
                          onBlur={handleFormBlur} >
                          <option value=''>Select Employee </option>
                          {userName.map((val) => {
                            return (
                              val?.role?.toLowerCase() !== "admin" && <option key={val._id} value={val._id}>{val.name}</option>
                            )
                          })}
                        </select>
                        {errors.userId && (
                          <small className="form-text error">{errors.userId}</small>
                        )}
                      </div>
                    </div>
                    {/* ====================   select  Date ============*/}
                    <div className="col-md-6">
                      <div className="form-group position-relative">
                        <label htmlFor="work_date" className='mt-3'>Work Date</label>
                        <div onClick={() => { dateRef.current.showPicker(); }}>
                          <input type="date"
                            className="form-control"
                            autoComplete='off'
                            ref={dateRef}
                            name='date'
                            value={form.date}
                            onChange={handleFormChange}
                            onBlur={handleFormBlur}
                          />
                          <CalendarMonthIcon className='calendar-icon-work' />
                          {errors.date && (
                            <small className="form-text error">{errors.date}</small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {rows.map((row, index) => (
                    <div className='education-wrapper mb-3' key={index}>
                      {rows.length > 1 &&
                        <div data-action="delete" className='delete text-right' >
                          <i className="fa-solid fa-trash-can " onClick={() => removeRow(index)}></i>
                        </div>}
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                            <label htmlFor="clock_in">Clock In</label>
                            <input type="time" className="form-control" name='clock_in' step="2" value={row.clock_in}
                              onChange={(e) =>
                                handleRowChange(index, e.target.name, e.target.value)
                              }
                              onBlur={() => handleRowBlur(index, "clock_in")} />
                            {errors.rows?.[index]?.clock_in && (
                              <small className="form-text error">
                                {errors.rows[index].clock_in}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col">
                          <div className="form-group">
                            <label htmlFor="clock_out">Clock Out</label>
                            <input type="time" className="form-control" name='clock_out' step="2" value={row.clock_out} onChange={(e) =>
                              handleRowChange(index, e.target.name, e.target.value)
                            }
                              onBlur={() => handleRowBlur(index, "clock_out")} />
                            {errors.rows?.[index]?.clock_out && (
                              <small className="form-text error">
                                {errors.rows[index].clock_out}
                              </small>
                            )}
                          </div>
                        </div>

                        {index === rows.length - 1 && (
                          <div className="col-12">
                            <NavLink onClick={addRow} className="active"><i className="fa-solid fa-circle-plus mr-1"></i> Add more</NavLink>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  {error.length !== 0 &&
                    <div className="row">
                      <div className="col-12 pl-md-2 pr-md-2">
                        <ErrorComponent errors={error} />
                      </div>
                    </div>}
                  <div className="row">
                    <div className='col-12 pl-md-2 pr-md-2 d-flex justify-content-center modal-button'>
                      <button type="submit" className="btn btn-gradient-primary mr-2" >Save</button>
                      <button className="btn btn-light" onClick={onClose}>Cancel</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {(Loading || isLoading) && <Spinner />}
        </Modal.Body>
      </Modal >
    </>
  );
};

export default AttendanceTimeModal;
